import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header = ({ sposo = "Marco", sposa = "Giulia", onConferma }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { path: '/', label: 'Home' },
    { path: '/location', label: 'Location' },
    { path: '/foto', label: 'Foto' },
    { path: '/regalo', label: 'Regalo' },
    { label: 'Conferma Partecipazione', isAction: true },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;1,300;1,400&family=Josefin+Sans:wght@200;300;400&display=swap');

        .wedding-header {
          /* Nuova palette */
          --dusty-blue: #c3e5ea;
          --dusty-blue-light: #e8ebe6;
          --dusty-blue-dark: #a8d5dd;
          --dusty-blue-deeper: #8ac4d0;
          --cream: #ffffff;
          --cream-warm: #fdfcfb;
          --cream-transparent: rgba(253, 252, 251, 0.95);
          --gold: #f6cdca;
          --gold-light: #f6cdca;
          --text-dark: #3a4a5c;
          --text-soft: #5a6a7c;

          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          z-index: 1000;
          font-family: 'Josefin Sans', sans-serif;
          transition: background 0.4s ease, box-shadow 0.4s ease;
        }

        .wedding-header.scrolled {
          background: var(--cream-transparent);
          backdrop-filter: blur(15px);
          box-shadow: 0 2px 30px rgba(164, 191, 223, 0.15);
        }

        .wedding-header * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .header-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 20px 40px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          transition: padding 0.4s ease;
        }

        .wedding-header.scrolled .header-container {
          padding: 15px 40px;
        }

        /* Logo / Names - REMOVED */
        .header-logo {
          display: none;
        }

        /* Desktop Navigation HIDDEN - We use hamburger only */
        .header-nav {
          display: none;
        }

        /* Mobile Menu Button - ALWAYS VISIBLE */
        .mobile-menu-btn {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 40px;
          height: 40px;
          background: none;
          border: none;
          cursor: pointer;
          gap: 5px;
          padding: 8px;
          z-index: 1100;
          position: relative;
        }

        .menu-line {
          width: 24px;
          height: 1.5px;
          background: var(--dusty-blue-dark);
          transition: all 0.3s ease;
          border-radius: 2px;
        }

        .mobile-menu-btn.open .menu-line:nth-child(1) {
          transform: rotate(45deg) translate(5px, 5px);
        }

        .mobile-menu-btn.open .menu-line:nth-child(2) {
          opacity: 0;
        }

        .mobile-menu-btn.open .menu-line:nth-child(3) {
          transform: rotate(-45deg) translate(5px, -5px);
        }

        /* Mobile Menu Overlay */
        .mobile-nav {
          display: flex; /* Always flex layout */
          position: fixed;
          top: 0;
          left: 0;
          width: 100vw;
          height: 100vh;
          background: var(--cream);
          flex-direction: column;
          align-items: center;
          justify-content: center;
          gap: 30px;
          opacity: 0;
          visibility: hidden;
          transition: all 0.4s ease;
          z-index: 999;
          overflow: hidden; /* Prevent scrolling inside menu if not needed */
        }

        .mobile-nav.open {
          opacity: 1;
          visibility: visible;
        }

        .mobile-nav .nav-link {
          font-size: 14px;
          letter-spacing: 6px;
          padding: 15px 30px;
          position: relative;
          font-family: 'Josefin Sans', sans-serif;
          font-weight: 300;
          text-transform: uppercase;
          text-decoration: none;
          color: var(--text-soft);
          transition: all 0.3s ease;
          background: none;
          border: none;
          cursor: pointer;
        }

        .mobile-nav .nav-link:hover, .mobile-nav .nav-link.active {
          color: var(--dusty-blue-deeper);
        }

        .nav-link-cta {
          color: #8ac4d0 !important;
          font-weight: 500 !important;
        }

        .mobile-nav-decoration {
          position: absolute;
          opacity: 0.15;
        }

        .mobile-nav-decoration.top-left {
          top: 40px;
          left: 40px;
        }

        .mobile-nav-decoration.bottom-right {
          bottom: 40px;
          right: 40px;
          transform: rotate(180deg);
        }

        /* Responsive Adjustments */
        @media (max-width: 768px) {
          .header-container {
            padding: 15px 20px;
          }

          .wedding-header.scrolled .header-container {
            padding: 12px 20px;
          }

          .logo-names {
            font-size: 20px;
          }
        }

        @media (max-width: 480px) {
          .logo-names {
            font-size: 18px;
          }
        }
      `}</style>

      <header className={`wedding-header ${isScrolled ? 'scrolled' : ''}`}>
        <div className="header-container">
          <div className="header-spacer" style={{width: '40px'}} /> {/* Spacer for balance if needed, or just leave it empty */}

          {/* Hamburger Menu Button - Always Visible */}
          <button 
            className={`mobile-menu-btn ${isMobileMenuOpen ? 'open' : ''}`}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            <span className="menu-line" />
            <span className="menu-line" />
            <span className="menu-line" />
          </button>
        </div>

        {/* Fullscreen Navigation Overlay */}
        <nav className={`mobile-nav ${isMobileMenuOpen ? 'open' : ''}`}>
          {/* Decorative tulips */}
          <div className="mobile-nav-decoration top-left">
            <svg width="80" height="120" viewBox="0 0 80 120">
              <path d="M40 120 L40 60" stroke="#c3e5ea" strokeWidth="2" />
              <path d="M40 65 Q20 45 25 20 Q32 0 40 8 Q48 0 55 8 Q60 0 58 20 Q65 45 40 65" fill="#f6cdca" />
            </svg>
          </div>
          <div className="mobile-nav-decoration bottom-right">
            <svg width="80" height="120" viewBox="0 0 80 120">
              <path d="M40 120 L40 60" stroke="#c3e5ea" strokeWidth="2" />
              <path d="M40 65 Q20 45 25 20 Q32 0 40 8 Q40 0 55 8 Q60 0 58 20 Q65 45 40 65" fill="#e8ebe6" />
            </svg>
          </div>

          {navItems.map((item, index) => (
            item.isAction ? (
              <button 
                key={index}
                className="nav-link nav-link-cta"
                onClick={() => {
                  setIsMobileMenuOpen(false);
                  onConferma();
                }}
              >
                {item.label}
              </button>
            ) : (
              <Link 
                key={index}
                to={item.path} 
                className={`nav-link ${isActive(item.path) ? 'active' : ''}`}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                {item.label}
              </Link>
            )
          ))}
        </nav>
      </header>
    </>
  );
};
export default Header;
